module.exports = __webpack_public_path__ + "img/portfolio1-m@1.4d778c45.jpg";